import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import axios from 'axios';

// Fetch casino results
export const fetchCasinoResults = createAsyncThunk(
  'casinoResults/fetchCasinoResults',
  async ({ game, date, limit, offset }, { rejectWithValue }) => {
    try {
      const params = {};
      if (date) params.date = date;
      if (limit !== undefined) params.limit = limit;
      if (offset !== undefined) params.offset = offset;

      const response = await api.get(`/user-history/casino-result/${game}`, { params });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch casino results' });
    }
  }
);
// Fetch dragon tiger 
export const dragantigerSettlementResult = createAsyncThunk(
  'casinoResults/dragantigerSettlementResult',
  async (_, { rejectWithValue }) => { 
    try {
      const response = await api.get(`/dragon-tiger/result`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch Two Card Teen Patti Result
export const TwoCardTeenPattiResult = createAsyncThunk(
  'casinoResults/TwoCardTeenPattiResult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/two-card/result`);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);


// Fetch Two twennty Teen Patti Result
export const TwoTweentyTeenPattiResult = createAsyncThunk(
  'casinoResults/TwoTweentyTeenPattiResult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/teen-patti/result`);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch lucky7 Result
export const lucky7result = createAsyncThunk(
  'casinoResults/lucky7result',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/lucky7/result');
      console.log('lucky7 response:', response.data); 
      return response.data;
    } catch (err) {
      console.log('lucky7 ERROR:', err.message);      
      console.log('lucky7 STATUS:', err.response?.status); 
      console.log('lucky7 DATA:', err.response?.data);   
      return rejectWithValue(err.response?.data || { message: 'Failed' });
    }
  }
);


// Fetch dtl Result
export const dtlresult = createAsyncThunk(
  'casinoResults/dtlresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/dtl/result`);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
        message: 'Failed to fetch casino results',
        }
      );
    }
  }
);


// Fetch card-32 Result
export const card32result = createAsyncThunk(
  'casinoResults/card32result',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/card-32/result`);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch bollywoodresultResult
export const bollywoodresult = createAsyncThunk(
  'casinoResults/bollywoodresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/bollywood/result`);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch baccaratresultResult
export const baccaratresult = createAsyncThunk(
  'casinoResults/baccaratresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/baccarat/result`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch aaaresultResult
export const aaaresult = createAsyncThunk(
  'casinoResults/aaaresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/aaa/result`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch OneDay-dtresultResult
export const onedaydtresult = createAsyncThunk(
  'casinoResults/onedaydtresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/oneday-dt/result`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

// Fetch OneDay-dtresultResult
export const anderbhaerresult = createAsyncThunk(
  'casinoResults/anderbhaerresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/andar-bahar/result`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);


export const aviatoresult = createAsyncThunk(
  'casinoResults/aviatoresult',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/aviator/result`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);

export const rouletteresult = createAsyncThunk(
  'casinoResults/rouletteresult',
  async (_, { rejectWithValue }) => {
    try {
      const response =  await api.get(`/roulette/result`);
      console.log("API Response:", response.data);
      return response.data;
    } catch (err) {
      console.log("API Error:", err.message);
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);


export const roulettRebet = createAsyncThunk(
  'casinoResults/roulettRebet',
  async (userId, { rejectWithValue }) => {
    try {
     const response = await api.get(`/roulette/last-round/${userId}`);

      return response.data;
    } catch (err) {
   
      return rejectWithValue(
        err.response?.data || {
          message: 'Failed to fetch casino results',
        }
      );
    }
  }
);




const casinoResultsSlice = createSlice({
  name: 'casinoResults',
  initialState: {
    records: [],
    TwoCardTeenPatti: [],
    dtl:[],
    card32:[],
    bollywood:[],
    baccarat:[],
    Rebet:[],
    lucky7:[],
    roulette:[],
    onedaydt:[],
    aaa:[],
    anderbhaer:[],
    dragantigerSettlementResult: [],
    TwoTweentyTeenPatti:[],
    total: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCasinoResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
  .addCase(fetchCasinoResults.fulfilled, (state, action) => {
    state.loading = false;
    state.records = Array.isArray(action.payload) ? action.payload : action.payload.records || [];
    state.total = action.payload.total || 0;
})
      .addCase(fetchCasinoResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Error fetching results';
      })

      //Fetch dragon tiger 
      .addCase(dragantigerSettlementResult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(dragantigerSettlementResult.fulfilled, (state, action) => {
        state.loading = false;
        state.dragantigerSettlementResult = action.payload || null;
      })

      .addCase(dragantigerSettlementResult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })



      // Fetch Two Card Teen Patti Result
      .addCase(TwoCardTeenPattiResult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(TwoCardTeenPattiResult.fulfilled, (state, action) => {
        state.loading = false;
        state.TwoCardTeenPatti = action.payload || null;
      })

      .addCase(TwoCardTeenPattiResult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

      // Fetch TwoTweentyTeenPattiResult Result
      .addCase(TwoTweentyTeenPattiResult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(TwoTweentyTeenPattiResult.fulfilled, (state, action) => {
        state.loading = false;
        state.TwoTweentyTeenPatti = action.payload || null;
      })

      .addCase(TwoTweentyTeenPattiResult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })


// Fetch lucky7 Result
      .addCase(lucky7result.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

 .addCase(lucky7result.fulfilled, (state, action) => {
    state.loading = false;
    console.log('lucky7 payload:', action.payload); 
    state.lucky7 = action.payload || null;
})
      .addCase(lucky7result.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

      // Fetch dtl Result
      .addCase(dtlresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(dtlresult.fulfilled, (state, action) => {
        state.loading = false;
        state.dtl = action.payload || null;
      })

      .addCase(dtlresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

  // Fetch Avioter Result
      .addCase(aviatoresult.pending, (state) => {
      state.loading = true;
      state.error = null;
      })

      .addCase(aviatoresult.fulfilled, (state, action) => {
        state.loading = false;
        state.aviator = action.payload || null;
      })

      .addCase(aviatoresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })


      
      // Fetch card32result Result
      .addCase(card32result.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(card32result.fulfilled, (state, action) => {
        state.loading = false;
        state.card32 = action.payload || null;
      })

      .addCase(card32result.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

           // Fetch bollywoodresult Result
      .addCase(bollywoodresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(bollywoodresult.fulfilled, (state, action) => {
        state.loading = false;
        state.bollywood = action.payload || null;
      })

      .addCase(bollywoodresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

       // Fetch baccaratresult Result
      .addCase(baccaratresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(baccaratresult.fulfilled, (state, action) => {
        state.loading = false;
        state.baccarat = action.payload || null;
      })

      .addCase(baccaratresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })



//// reoutet reslut


       .addCase(rouletteresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(rouletteresult.fulfilled, (state, action) => {
        state.loading = false;
        state.roulette = action.payload || null;
      })

      .addCase(rouletteresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

      ///rebet
       .addCase(roulettRebet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(roulettRebet.fulfilled, (state, action) => {
        state.loading = false;
        state.Rebet = action.payload || null;
      })

      .addCase(roulettRebet.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })













          // Fetch aaaatresult Result
      .addCase(aaaresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(aaaresult.fulfilled, (state, action) => {
        state.loading = false;
        state.aaa = action.payload || null;
      })

      .addCase(aaaresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })

      // Fetch onedaydtresult Result
      .addCase(onedaydtresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(onedaydtresult.fulfilled, (state, action) => {
        state.loading = false;
        state.onedaydt = action.payload || null;
      })

      .addCase(onedaydtresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      })
      // Fetch anderbhaerresult Result
      .addCase(anderbhaerresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

.addCase(anderbhaerresult.fulfilled, (state, action) => {
  state.loading = false;
  const payload = action.payload;
  // Normalize to always be an array
  state.anderbhaer = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
    ? payload.data
    : payload
    ? [payload]
    : [];
})
      .addCase(anderbhaerresult.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Error fetching results';
      });
  },
});

export default casinoResultsSlice.reducer;
